<template>
  <div class="home">
    <img :src="pic1" alt="">
    <img :src="pic2" alt="">
    <p><span><a style="color:#2c3e50;text-decoration: none;" href="https://beian.miit.gov.cn/">粤ICP备13053897号</a></span>
      Copyright ©2025 -
      广州市润心文化有限公司</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      pic1: require('@/assets/pic1.png'),
      pic2: require('@/assets/pic2.png'),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  img {
    width: 100%;
  }
}
</style>
